<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6FtiyY/images/Cover.jpg?1736996206437" alt="This image is the cover for the book Food, Hope & Resilience, American Palate"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Food, Hope & Resilience, American Palate
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Culinary Traditions Preserved, Stories Never to be Forgotten</strong></p> <p>This vital collection of survivor stories uplifts and inspires alongside recipes that nourish your soul. Read about daring partisans who fought in the woods, hidden children who sought comfort from strangers and those who endured unimaginable internment. For Holocaust survivors, food was a way to connect their lives before the war with the homes they created after. Their kitchens were filled with the aromas of familiar foods like chicken soup and brisket while unfamiliar delights they adopted, like arroz con pollo and gnocchi, became part of their repertoire. These are the recipes they share with you. Culinary icons such as Michael Solomonov, Jonathan Waxman, Ina Garten and more contribute their own recipes as tribute to the remarkable survivor community. Author June Hersh gives readers a taste of history and a life-affirming message that honors the legacy of Holocaust survivors. </p> A portion of the proceeds from sales of this book will benefit organizations committed to Holocaust education.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        June Hersh, Daniel Boulud
      </h2>
      
      <p class="authorDescription body article">June Hersh is a former teacher and businesswoman who began her food writing career after retiring in 2004. She is the author of The Kosher Carnivore (St. Martin's Press, September 2011), a primer on how to cook kosher meat and poultry; Yoghurt: A Global History (Reaktion Books, March 2021) and Iconic New York Jewish Food: A History and Guide with Recipes (The History Press, February 2023). Hersh served as editor and interviewer for Still Here: Inspiration from Survivors and Liberators of the Holocaust (www.stillherebook.com). Her books are available on her website (www.junehersh.com) and other online booksellers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ec27b10